/** Telegram haptics (no-op outside Telegram). type: light | medium | heavy | rigid | soft */
export function haptic(type = 'light') {
  try {
    window.Telegram?.WebApp?.HapticFeedback?.impactOccurred?.(type);
  } catch (e) { /* ignore */ }
}

/** type: success | error | warning */
export function hapticNotify(type = 'success') {
  try {
    window.Telegram?.WebApp?.HapticFeedback?.notificationOccurred?.(type);
  } catch (e) { /* ignore */ }
}

export function hapticSelect() {
  try {
    window.Telegram?.WebApp?.HapticFeedback?.selectionChanged?.();
  } catch (e) { /* ignore */ }
}
